// import Test from 'redux/store/Test/resucer'
import { combineReducers } from '@reduxjs/toolkit'
import Select from 'redux/store/Select/SelectSlice'
import Global from 'redux/store/Global/GlobalSlice'

import { ConfigurationsAPI } from 'redux/store/Configurations/ConfigurationsAPI'
import { GlobalAPI } from './Global/GlobalAPI'
import { UserInfoAPI } from './UserInfo/UserInfoAPI'

import UserInfo from './UserInfo/UserInfoSlice'

import { ProfileAPI } from './Profile/ProfileAPI'
import { FlightAPI } from './Flight/FlightAPI'
import { CateringAPI } from './Catering/CateringAPI'
import { GroupsAPI } from './Groups/GroupsAPI'
import { ReservationsAPI } from './Reservations/ReservationsAPI'
import { UsersApi } from './users/UsersApi'
import {
  RoomsApi,
  HotelsAPI,
  HotelPricingApi,
  HotelOfferApi,
  TransportationsAPI,
  ClientsAPI,
  PackagesAPI,
  MarketPlaceAPI,
} from './actions'

export * from './UserInfo/UserInfoSlice'
const allReducer = combineReducers({
  Select,
  Global,
  UserInfo,
  [GlobalAPI.reducerPath]: GlobalAPI.reducer,
  [ConfigurationsAPI.reducerPath]: ConfigurationsAPI.reducer,

  [UserInfoAPI.reducerPath]: UserInfoAPI.reducer,
  [ProfileAPI.reducerPath]: ProfileAPI.reducer,
  [FlightAPI.reducerPath]: FlightAPI.reducer,
  [UsersApi.reducerPath]: UsersApi.reducer,
  [HotelsAPI.reducerPath]: HotelsAPI.reducer,
  [RoomsApi.reducerPath]: RoomsApi.reducer,
  [HotelPricingApi.reducerPath]: HotelPricingApi.reducer,
  [HotelOfferApi.reducerPath]: HotelOfferApi.reducer,
  [TransportationsAPI.reducerPath]: TransportationsAPI.reducer,
  [ClientsAPI.reducerPath]: ClientsAPI.reducer,
  [CateringAPI.reducerPath]: CateringAPI.reducer,
  [GroupsAPI.reducerPath]: GroupsAPI.reducer,
  [PackagesAPI.reducerPath]: PackagesAPI.reducer,
  [ReservationsAPI.reducerPath]: ReservationsAPI.reducer,
  [MarketPlaceAPI.reducerPath]: MarketPlaceAPI.reducer,
})
const rootReducer = (state: any, action: { type: string }): any => {
  let newState = { ...state }
  if (action.type === 'RESET_APP') {
    newState = {}
  }

  return allReducer(newState, action)
}
export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
